import React, { useEffect, useState } from 'react';

const CART_KEY = 'ShelfyCart';

const readCart = () => {
  if (typeof window === 'undefined') return [];
  try {
    const stored = JSON.parse(window.localStorage.getItem(CART_KEY) || '[]');
    return Array.isArray(stored) ? stored.filter(item => item?.listingId) : [];
  } catch (error) {
    return [];
  }
};

const writeCart = items => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(CART_KEY, JSON.stringify(items));
    window.dispatchEvent(new Event('shelfy-cart-change'));
  }
  return items;
};

export const getCartItems = () => readCart();
export const addCartItem = item => {
  const items = readCart();
  return items.some(existing => existing.listingId === item.listingId)
    ? items
    : writeCart([
        ...items,
        { listingId: item.listingId, acceptedOfferId: item.acceptedOfferId || null },
      ]);
};
export const removeCartItem = listingId =>
  writeCart(readCart().filter(item => item.listingId !== listingId));
export const removeCartItems = listingIds => {
  const purchased = new Set(listingIds);
  return writeCart(readCart().filter(item => !purchased.has(item.listingId)));
};
export const getCartCheckoutKey = (sellerId, items = []) => {
  if (typeof window === 'undefined') return null;
  const fingerprint = items
    .map(item => `${item.listingId}:${item.acceptedOfferId || ''}`)
    .sort()
    .join('|');
  const key = `ShelfyCartCheckout:${sellerId}:${fingerprint}`;
  const existing = window.sessionStorage.getItem(key);
  if (existing) return existing;
  const value =
    typeof window.crypto?.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random()
          .toString(16)
          .slice(2)}`;
  window.sessionStorage.setItem(key, value);
  return value;
};
export const clearCartCheckoutKey = (sellerId, items = []) => {
  if (typeof window !== 'undefined') {
    const fingerprint = items
      .map(item => `${item.listingId}:${item.acceptedOfferId || ''}`)
      .sort()
      .join('|');
    window.sessionStorage.removeItem(`ShelfyCartCheckout:${sellerId}:${fingerprint}`);
  }
};
export const cartHasListing = listingId => readCart().some(item => item.listingId === listingId);
export const useCartItems = () => {
  const [items, setItems] = useState(readCart);
  useEffect(() => {
    const sync = () => setItems(readCart());
    window.addEventListener('shelfy-cart-change', sync);
    return () => window.removeEventListener('shelfy-cart-change', sync);
  }, []);
  return items;
};
